module.exports = __webpack_public_path__ + "static/media/plesk.41f00ea7.svg";